import { createStore } from 'vuex'

const aid = (window.location.host == 'mtest.thecover.cn' || window.location.port) ? '61dfa3011422f4002e097b91' : '625e1e7126fb81005b2964f9'

export default createStore({
    state: {
        aid: aid, // 正式活动id
        // aid: '61dfa3011422f4002e097b91', // 测试活动id
        musicUrl: '',
        musicPaused: false, // 音乐播放状态
        userInfo: {}, // 用户信息
        shareData: {}, // 分享信息
        dialogData: null, // 弹框数据
        activityData: null, // 活动数据
        popData: null
    },
    mutations: {
        SET_MUSICURL (state, url: string) {
            state.musicUrl = url
        },
        SET_MUSICPAUSED (state, flag: boolean) {
            state.musicPaused = flag
        },
        SET_USERINFO (state, data) {
            state.userInfo = data
        },
        SET_SHAREDATA (state, data) {
            state.shareData = data
        },
        SET_DIALOGDATA (state, data) {
            state.dialogData = data
        },
        SET_ACTIVITYDATA (state, data) {
            state.activityData = data
        },
        SET_POPDATA (state, data) {
            state.popData = data
        }
    },
    actions: {
    },
    modules: {
    }
})
